import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from '@components/catalog/catalog-hotfilters/catalog-hotfilters.module.scss';

interface CatalogHotfiltersScrollWrapperProps {
  isLayoutChangeRef: React.RefObject<boolean>;
  scrollRef: React.RefObject<HTMLDivElement>;
  isFilterOpen: boolean;
}

const CatalogHotfiltersScrollWrapper: React.FCWithChildren<CatalogHotfiltersScrollWrapperProps> = ({
  isLayoutChangeRef,
  scrollRef,
  isFilterOpen,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    // This handles the scroll behaviour of the hotfilter container
    const handleScroll = () => {
      if (isLayoutChangeRef.current) {
        return;
      }
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current) {
        // User is scrolling down, hide the hotfilters
        setIsVisible(false);
      } else {
        // User is scrolling up, show the hotfilters
        setIsVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/*This div is used as an anchor for scrolling back up to top*/}
      <div ref={scrollRef} />
      <div
        className={clsx(
          styles.catalogHotfilters,
          isFilterOpen && styles.catalogHotfilters__open,
          !isVisible && styles.catalogHotfilters__hide,
        )}
      >
        {children}
      </div>
    </>
  );
};

export default CatalogHotfiltersScrollWrapper;
